// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JP2qdk7mdFGXr4bcKANM {
  width: 520px;
}
.xW7F0WQMH5wheYjJhRN2 {
  width: 100%;
}

.eKB687Rsc0fp07ogPRhf {
  width: 275px;
}

.ZoMyQpFtoqWK3ZpDGJG2 {
  padding-right: 315px;
}

.fMI3vrT3ITU2_QrnQJPA {
  gap: 40px;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/samples/components/reanalyze/reanalyze-form/reanalyze-form.module.scss"],"names":[],"mappings":"AAEE;EACE,YAAA;AADJ;AAIE;EACE,WAAA;AAFJ;;AAMA;EACE,YAAA;AAHF;;AAMA;EACE,oBAAA;AAHF;;AAMA;EACE,SAAA;AAHF","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.password_field {\n  &_large {\n    width: 520px;\n  }\n\n  &_medium {\n    width: 100%;\n  }\n}\n\n.integration_analysis_container {\n  width: 275px;\n}\n\n.static_analysis_analysis_container {\n  padding-right: 315px;\n}\n\n.container_gap {\n  gap: 40px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"password_field_large": `JP2qdk7mdFGXr4bcKANM`,
	"password_field_medium": `xW7F0WQMH5wheYjJhRN2`,
	"integration_analysis_container": `eKB687Rsc0fp07ogPRhf`,
	"static_analysis_analysis_container": `ZoMyQpFtoqWK3ZpDGJG2`,
	"container_gap": `fMI3vrT3ITU2_QrnQJPA`
};
export default ___CSS_LOADER_EXPORT___;
